<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.1" height="17.1" viewBox="0 0 17.1 17.1">
    <path class="a" fill="none" stroke="currentColor" stroke-width="1.5px"
          d="M18.164,10.161a7.06,7.06,0,0,1-.758,3.2,7.161,7.161,0,0,1-6.4,3.96,7.06,7.06,0,0,1-3.2-.758L3,18.164l1.6-4.8a7.06,7.06,0,0,1-.758-3.2,7.161,7.161,0,0,1,3.96-6.4A7.06,7.06,0,0,1,11,3h.421a7.144,7.144,0,0,1,6.74,6.74Z"
          transform="translate(-1.814 -2.25)"/>
  </svg>
</template>
